"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var StorageAccountsFull_1 = require("./components/StorageAccountsFull");
var StorageAccountsOption = {
    key: 'storageAccounts',
    titleStringKey: 'optionTitle_storageAccounts',
    searchTermsStringKey: 'optionTitle_storageAccounts',
    fullOptionFormSettings: {
        render: function () { return React.createElement(StorageAccountsFull_1.default, null); },
        isDirty: function () { return false; },
        onSave: function () { return Promise.resolve(); },
        onDiscard: function () { },
    },
};
exports.default = StorageAccountsOption;
//# sourceMappingURL=StorageAccountsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-storage-accounts-option/lib/StorageAccountsOption.js
// module id = 4986
// module chunks = 2